import { render, staticRenderFns } from "./DialogPageChatMessageSender.vue?vue&type=template&id=47beaccf"
import script from "./DialogPageChatMessageSender.vue?vue&type=script&lang=js"
export * from "./DialogPageChatMessageSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports